module.exports = new __parcel__URL__("nft-wevr.683bb794.png").toString();